<template>
  <div>

    <default-financial-card :value="data_total" :title="title" :icon="icon" :title_class="title_class" :icon_color="icon_color" style="height: 100%" >
      <template v-slot:main_data>
        <div>
          <span class="headline mt-0 font-weight-black">{{data_total}}</span> 
          <span class="caption mt-0 font-weight-normal">/ {{data_goal}} </span>
        </div>
      </template>
      <template v-slot:extra>
        <div class="subtitle-2 d-flex align-center font-weight-black caption black--text" style="text-align: right;">
          {{data_percent}}%
          <v-progress-linear style="border-radius:20px;" class="ml-1" :value="data_percent" height="8" background-color="grey" color="teal accent-4">
          </v-progress-linear>
        </div>
      </template>
      
    </default-financial-card>

  </div>
</template>

<script>
export default {
  name: 'Reservation',

  components: {
    DefaultFinancialCard: () => import ('./DefaultFinancialCard.vue'),
  },

  props: {
    data: {
      type: Object,
    },
  },

  data() {
    return {
      // value: 14000,
      value_percent: 70,
      title: 'RESERVA',
      icon: 'mdi-database-lock-outline',
      title_class: 'amber--text overline',
      icon_color: 'amber',
    }
  },

  computed: {
    data_total() {
      let val = 0
      if (this.data && this.data.total){
        val = (Number(this.data.total)/100)
      }
      return Number(val).toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'}) 
    },
    data_goal() {
      let val = 0
      if (this.data && this.data.savings_goal){
        val = (Number(this.data.savings_goal)/100)
      }
      return Number(val).toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'}) 
    },
    data_percent() {
      let val = 0
      if (this.data){
        let {total, base_monthly_goal} = this.data
        val = (Number((total || 0) / (base_monthly_goal||1))*100).toFixed(2)
      }
      return val
    },
  },

}
</script>

<style lang="scss" scoped>

</style>